import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Checkbox, Button, Select, Tooltip, Icon } from 'antd'
import css from './phone-numbers.css'

const { Option } = Select

const PhoneNumberDetailsForm = ({
  businesses,
  error,
  editingPhoneNumberId,
  handleCancelDelete,
  handleCheck,
  handleDelete,
  handleSelectedBusiness,
  handleTextChange,
  locations,
  phoneNumberText,
  preferredNumber,
  selectedLocationIds,
  selectedBusinessId,
  toggleLocation,
  twilioSid,
  willDelete,
}) => {
  const checked = locationId => selectedLocationIds.includes(locationId)

  return (
    <Form>
      <Form.Item>
        <div className="ant-checkbox-modifier">
          <style>
            {`.ant-checkbox-modifier .ant-checkbox-wrapper {
                margin-left: 0;
              }`}
          </style>
          <h4>
            Business&nbsp;
            <Tooltip
              key="business-tooltip"
              title={
                <span>
                  The business is used for Twilio compliance. If the business
                  doesn&apos;t have an EIN, all messages will be appended with
                  the attribution &quot;-&nbsp;messaging by RoosterGrin&quot;
                  (or Tops).
                  <br />
                  <br />
                  Note that we also have to attribute messages during the Twilio
                  approval process, which takes a few days.
                </span>
              }
              placement="top"
              arrowPointAtCenter
            >
              <Icon type="question-circle" theme="outlined" />
            </Tooltip>
          </h4>
          <div className={css.locationCheckboxes}>
            <Select
              name="business"
              onChange={handleSelectedBusiness}
              value={selectedBusinessId}
            >
              <Option key="no-business-selected" value={null}>
                None Selected
              </Option>
              {businesses.length &&
                businesses.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      </Form.Item>
      <Form.Item>
        <h4>Phone Number</h4>
        <div className={css.manualInputs}>
          <div className={css.manualInput}>
            <span className={css.labelSmall}>Phone Number</span>
            <Form.Item>
              <Input
                disabled={!!editingPhoneNumberId}
                placeholder="e.g. +14152223333"
                value={phoneNumberText}
                name="phoneNumberText"
                onChange={handleTextChange}
              />
            </Form.Item>
          </div>
          <div className={css.manualInput}>
            <span className={css.labelSmall}>Twilio SID</span>
            <Form.Item>
              <Input
                disabled={!!editingPhoneNumberId}
                placeholder="e.g. PNXXXXXXXXXXXXXXXXX"
                value={twilioSid}
                name="twilioSid"
                onChange={handleTextChange}
              />
            </Form.Item>
          </div>
        </div>
        <Form.Item style={{ margin: '12px 0' }}>
          <Checkbox
            key="preferredNumber"
            name="preferredNumber"
            onChange={handleCheck}
            checked={preferredNumber}
          >
            Preferred Number
          </Checkbox>
        </Form.Item>
      </Form.Item>
      {!!error && <div className={css.errorText}>{error}</div>}
      <Form.Item style={{ margin: 0 }}>
        <div className="ant-checkbox-modifier">
          <style>
            {`.ant-checkbox-modifier .ant-checkbox-wrapper {
                margin-left: 0;
              }`}
          </style>
          <h4>Locations</h4>
          <div className={css.locationCheckboxes}>
            {!!locations &&
              locations.map(({ id, name }) => (
                <Checkbox
                  key={id}
                  checked={checked(id)}
                  name="location"
                  onChange={toggleLocation}
                  value={id}
                >
                  {name}
                </Checkbox>
              ))}
          </div>
        </div>
      </Form.Item>
      {!!editingPhoneNumberId && (
        <div className={css.deleteNumber}>
          {willDelete ? (
            <div className={css.willDelete}>
              <span className={css.deleteHelp}>
                This will permanently release the number from our system and is
                non-reversible. If you want to remove the phone number from a
                location, use the checkboxs above to unselect it.
              </span>
              <div className={css.deleteButtons}>
                <Button onClick={handleCancelDelete}>
                  <span>Cancel</span>
                </Button>
                <Button onClick={handleDelete}>
                  <span className={css.dangerText}>Confirm</span>
                </Button>
              </div>
            </div>
          ) : (
            <Button onClick={handleDelete}>
              <span className={css.dangerText}>Delete From All Locations</span>
            </Button>
          )}
        </div>
      )}
    </Form>
  )
}

PhoneNumberDetailsForm.propTypes = {
  businesses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  error: PropTypes.string,
  editingPhoneNumberId: PropTypes.number,
  handleCancelDelete: PropTypes.func.isRequired,
  handleCheck: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleSelectedBusiness: PropTypes.func.isRequired,
  handleTextChange: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  phoneNumberText: PropTypes.string.isRequired,
  preferredNumber: PropTypes.bool.isRequired,
  selectedBusinessId: PropTypes.number,
  selectedLocationIds: PropTypes.arrayOf(PropTypes.string.isRequired)
    .isRequired,
  toggleLocation: PropTypes.func.isRequired,
  twilioSid: PropTypes.string.isRequired,
  willDelete: PropTypes.bool.isRequired,
}

PhoneNumberDetailsForm.defaultProps = {
  editingPhoneNumberId: null,
  error: '',
  selectedBusinessId: null,
}

export default PhoneNumberDetailsForm



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/PhoneNumberDetailsForm.js